<template>
  <Wrapper :client="client">
    <div class="w-full">
      <project-list :projects="projects" />
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from './Wrapper.vue';
import ProjectList from '../../ComponentsDeprecated/ProjectList.vue';

export default {
  name: 'ProjectsTab',
  components: {
    ProjectList,
    Wrapper,
  },

  props: {
    client: Object,
    projects: Object,
    paginate: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
    };
  },

  watch: {},
  created() {},
  methods: {
  },
};
</script>

<style scoped>

</style>
